import _invariant                   from 'invariant';
import PropTypes                    from 'prop-types';
import {
  mapProps,
  setDisplayName,
  setPropTypes
}                                   from 'recompose';
import { MapResourceNamePropTypes } from './mapResourceName';
import {
  MAP_RESOURCE_PROP_API_URL,
  MAP_RESOURCE_PROP_RESOURCE_ID,
  MAP_RESOURCE_PROP_RESOURCE_NAME
}                                   from './mapResourceProps.const';


const mapResourceItemApiUrlFromId = (/* Reserved for future config */) =>
  (Component) =>
    setDisplayName('MapResourceItemApiUrlFromId')(
      setPropTypes({

        ...MapResourceNamePropTypes,

        // The slug of the resource.
        [MAP_RESOURCE_PROP_RESOURCE_ID]: PropTypes.string.isRequired,

      })(
        mapProps(({...props}) => {

          const {
                  [MAP_RESOURCE_PROP_RESOURCE_NAME]: resourceName,
                  [MAP_RESOURCE_PROP_RESOURCE_ID]:   resourceId,
                } = props;

          _invariant(resourceId, `Missing '${MAP_RESOURCE_PROP_RESOURCE_ID}' for ${resourceName}`);

          props[MAP_RESOURCE_PROP_API_URL] = resourceId;

          return props;

        })(Component)
      )
    );


export const MapResourceItemApiUrlFromIdPropTypes = {

  // URL for the resource collection.
  [MAP_RESOURCE_PROP_API_URL]: PropTypes.string.isRequired,

};


export default mapResourceItemApiUrlFromId;


// WEBPACK FOOTER //
// ./src/components/resources/mapResourceItemApiUrlFromId.js